import { logger } from '@/utils/logger'

/** Desktop hub hash offset. Matches `md:scroll-mt-36` (9rem / 144px). Sidebar is lg+ only. */
export const HUB_SECTION_SCROLL_OFFSET_PX = 144

/**
 * Smoothly scrolls to an element with a given offset
 * @param elementId - The ID of the element to scroll to
 * @param offset - The offset from the top in pixels (default: 0)
 * @returns boolean - Returns true if element was found and scrolled to, false otherwise
 */
export function smoothScrollToElement(elementId: string, offset: number = 0): boolean {
  const element = document.getElementById(elementId)
  
  if (!element) {
    logger.warn('Element not found for smooth scroll', { elementId })
    return false
  }

  const elementPosition = element.getBoundingClientRect().top
  const offsetPosition = elementPosition + window.pageYOffset - offset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })

  return true
}

/**
 * Smoothly scrolls to a specific Y position
 * @param yPosition - The Y position to scroll to
 */
export function smoothScrollToPosition(yPosition: number): void {
  window.scrollTo({
    top: yPosition,
    behavior: 'smooth',
  })
}

/**
 * Smoothly scrolls to the top of the page
 */
export function smoothScrollToTop(): void {
  smoothScrollToPosition(0)
}

